module.exports = __webpack_public_path__ + "resources/img/bg_solution_main4.f0c32176a87a483888146d437e69b21f.png";